


























































import Collapsible from '@/components/layout/Collapse.vue'
import Vue from 'vue'

export const showInMenu = {
  withLabel: 'Über uns',
  andPath: '/ueber-uns',
}

export default Vue.extend({
  components: { Collapsible },
  data: () => ({
    content: 'Hallo Welt, dies ist ein Test!',
  }),
})
